import React from 'react';

const BurgerButton = ({ onClick }) => (
    <button onClick={onClick} className='flex flex-col justify-center w-10 h-10 p-2'>
        <div className='w-6 h-[2px] bg-white rounded-lg mb-[5px]'></div>
        <div className='w-4 h-[2px] bg-white rounded-lg mb-[5px]'></div>
        <div className='w-6 h-[2px] bg-white rounded-lg'></div>
    </button>
);

export default BurgerButton;
